export default {
  transactions: 'Transactions',
  posted: 'Posted',
  instructed: 'Instructed',
  instructedAmount: 'Instructed amount',
  description: 'Description',
  dateAndTime: 'Date and time',
  status: 'Status',
  loadMore: 'Load more',
  allLoaded: 'All transactions are loaded',
  fromCreatedAt: 'Date from',
  toCreatedAt: 'Date to',
  terminal: 'Terminal',
  location: 'Location',
  employee: 'Employee',
  operationType: 'Transaction type',
  baseAmount: 'Base amount',
  convertedAmount: 'Converted amount',
  exchangeRate: 'Exchange rate',
  amount: 'Transfer amount',
  totalAmount: 'Total amount',
  recipientAccount: 'Recipient account',
  senderAccount: 'Sender account',
  postedAmount: 'Posted amount',
  you: '(you)',
  showMore: 'Show more',
  currency: 'Currency',
  MCC: 'MCC',
  merchantCategoryCode: 'Merchant Category Code',
  paymentTokenType: 'Payment token type',
  paymentTokenTypeDYNAMIC: 'DYNAMIC payment token',
  paymentTokenTypeSTATIC: 'STATIC payment token',
  account: 'Account',
  lastTransactions: 'Last transactions',
  date: 'Date',
  notDefined: 'Not defined',
  counterpartyAccount: 'Counteryparty account',
  amounts: 'Amounts',
  postingDate: 'Posting date',
  comment: 'Comment',
  reference: 'Reference',
  transferType: 'Transfer type',
  // Operation types
  P2P_TRANSFER: 'P2P Transfer',
  PURCHASE: 'Purchase',
  REFUND: 'Refund',
  MEMBERSHIP: 'Membership',
  BILL_PAYMENT: 'Outgoing transfer',
  PAYOUT: 'Payout',
  TENANT_FEE: 'Fee',
  TOP_UP: 'Account Topup',
  CASH_DEPOSIT: 'Cash deposit',
  CASH_WITHDRAWAL: 'Cash withdrawal',
  OWN_ACCOUNTS_TRANSFER: 'Own account transfer',
  REMITTANCE_PAYOUT: 'Remittance payout',
  REVERSAL: 'Reversal',
  FORCED_APPROVAL: 'Forced Approval',
  INCOMING_TRANSFER: 'Incoming Transfer',
  ACCOUNT_TRANSFER: 'Account transfer',
  SERVICE_CHARGE: 'Service charge',
  CASH_COLLECTION: 'Cash Collection',
  CARD_TRANSACTION: 'Card Transaction',
  DIRECT_TRANSFER: 'Direct Transfer',
  DEBIT_ORDER: 'Debit Order',
  'Date & time ({{timeZone}})': 'Date & time ({{timeZone}})',
  'Transaction ID': 'Transaction ID',
  'Transaction type': 'Transaction type',
  Description: 'Description',
  Terminal: 'Terminal',
  Location: 'Location',
  Employee: 'Employee',
  Status: 'Status',
  Sender: 'Sender',
  Recipient: 'Recipient',
  'Instructed amount': 'Instructed amount',
  'Base amount': 'Base amount',
  'Acquiring fee': 'Acquiring fee',
  'Exchange rate': 'Exchange rate',
  'Transfer amount': 'Transfer amount',
  Fees: 'Fees',
  'Posted amount': 'Posted amount',
  'Payment token type': 'Payment token type',
  'Payment token value': 'Payment token value',
  'Transfer is processing': 'Transfer is processing',
  'Please wait...': 'Please wait...',
  'Transfer done': 'Transfer done',
  'Transfer rejected': 'Transfer rejected',
  'Transfer in progress': 'Transfer in progress',
  transferId: 'Transfer ID: {{id}}',
  FEE: 'Fee',
  TAX: 'Tax',
  LOYALTY: 'Loyalty',
  ACQUIRING_FEE: 'Acquiring fee',
  CASH_ACQUIRING_FEE: 'Cash acquiring fee',
  maskedPan: 'Card',
  terminalId: 'Terminal Id',
  merchantId: 'Merchant Id',
  merchantName: 'Merchant name',
  merchantCity: 'Merchant city',
  merchantCountry: 'Merchant country',
  references: 'References',
  runningBalance: 'Running balance',
  referenceId: 'Reference ID',
};
